var render = function render(){var _vm=this,_c=_vm._self._c;return _c('zy-monitor',{attrs:{"channel-no":_vm.channelNo,"cameraIndexCode":_vm.cameraIndexCode,"quality":_vm.quality,"templateId":_vm.templateId}})
}
var staticRenderFns = []

export { render, staticRenderFns }